<template>
  <modal name="tempStoragePopup" :width="1180" :height="580" :clickToClose="false" @before-open="beforeOpen" @opened="opened">

    <div id="div_tempStoragePopup" class="popup on"  >  
      <div class="pop_tit">임시저장 조회(일반)</div>
      <div id="div_tempStoragePopupScroll"  class="pop_con_wrap scroll_area" style="height:470px;">
              <div class="sub_search_wrap">
                <div class="search_form_cell">
                  <div class="cell">
                      <label for="주문처">주문처</label>
                      <div class="cell_se_input">
                          <span><input type="text" id="customerName" class="input-view"  placeholder="주문처를 입력하세요" autocomplete="off" 
                          v-model.lazy.trim="grid_options.general.params.customerName"></span>
                      </div>
                  </div>
                  <div class="cell">
                    <label for="작성자">작성자</label>
                    <div class="cell_se_input">
                      <span><input type="text" id="작성자" class="input-view" placeholder="작성자를 입력하세요" autocomplete="off" 
                                  v-model.lazy.trim="grid_options.general.params.userName"></span>
                    </div>
                  </div>
                  <div class="cell">
                    <label for="">차량번호</label>
                    <div class="cell_se_input">
                      <span><input type="text" id="차량번호" class="input-view" placeholder="차량번호를 입력하세요" autocomplete="off" 
                                  v-model.lazy.trim="grid_options.general.params.carId"></span>
                    </div>
                  </div>
                </div>
                <div class="search_form_cell">
                  <div class="cell">
                      <label for="">브랜드</label>
                      <div class="cell_select-02 w280">
                        <div class="cell_se_bg-02">
                          <select class="select" v-model.lazy.trim="grid_options.general.params.brandNo">
                              <option value=''>브랜드를 선택하세요</option>
                              <option v-for="option in selectBox_options.brandCodeVo" v-bind:value="option.value" v-bind:key="option.text">
                              {{option.text}}
                              </option>
                          </select>
                        </div>
                      </div>
                  </div>
                  <div class="cell">
                      <label for="">저장일자</label>
                      <div class="date_wrap vam">
                        <div class="date_input">
                          <span class="inputbd w120"><inputDate  id="저장일자시작" placeholder="저장일자를 선택하세요" autocomplete="off" 
                                      v-model.lazy.trim="grid_options.general.params.createTimestampStart"/></span>
                          
                        </div>
                        <div class="date_input pl10" >
                          <span class="inputbd w120"><inputDate  id="저장일자끝"  placeholder="저장일자를 선택하세요" autocomplete="off" 
                                      v-model.lazy.trim="grid_options.general.params.createTimestampEnd"/></span>
                          
                        </div>
                      </div>
                  </div>
                  <div class="cell">
                    <label for="">저장번호</label>
                    <div class="cell_se_input">
                      <span><input type="text" id="저장번호" class="input-view" placeholder="저장번호를 입력하세요" autocomplete="off" 
                                  v-model.lazy.trim="grid_options.general.params.orderId"></span>
                    </div>
                  </div>
                </div>
                <div class="sub_sh_btn_wrap">
                  <a href="javascript:void(0);" class="sh_btn pt5 pb5 pl20 pr20"  @click="searchTempStorage">조회</a>
                </div>
              </div>
              <div class="sub_search_wrap mt10" style="width:1100px; height:235px;">
                  <div class="board_list type02" >
                    <div class="sub_left_wrap">
                      <div class="destxt pb10">조회결과 <span>{{this.gridTotal}}</span>건 </div>
                    </div>
                    <div class="sub_right_wrap">
                      <div class="destxt pb10">배송처 항목값을 클릭하면,<span>임시저장</span>된, 내역을 불러옵니다.</div>
                    </div>
                    <grid :options="grid_options" v-once></grid>
                  </div>
              </div>
      </div>

      <div class="pop_footer_wrap">
              <div class="btn_area mt0">
                <a href="javascript:void(0);" class="button dark"><span>닫기</span>
                </a><a href="javascript:void(0);" class="button blue" @click="sendTempStorageData"><span>선택</span></a>
              </div>
      </div>
          <a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
    </div>
    
  </modal>
</template>
<script> 
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'
import InputDate from '@/components/InputDate'
import { isNullOrUndefined } from 'util';


export default {
  name: 'tempStoragePopup',
  components: { Grid, GridModule, Vue, InputDate },
  props: { //부모창으로 부터 받은 속성값(변동되는 data, 정적 data를 부모로부터 받음)
    value : '', //props는 자식이 부모 컴포넌트로부터 넘겨받은 data를 사용 할 수 있게 한다.
    options: {  //props 옵션명이 정해져 있나봄.. value아니면 안되는듯..(tempStorageParam으로 이름 정하고 통일시켜도 안됨..)
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      pushToParent: '', //자식이 부모창으로 전달
      loginInfo: [],
      tempStorageInfo : [],
      gridTotal : '',
      selectBox_options : {
          brandCodeVo : ''
      },
      // 또는 pushToParent: {
      //   data1: '',
      //   data2: '',
      //   data3: ''
      // },
      grid_options : {
        general : {
          id  : 'temp-storage-popup-grid',
          search : '',
          excel : false,          
          type : {
            isUpdate : false,
          },
          PageInfo : {
          },
          params : {
                customerName : '',
                createUserNo : '',
                userName: '',
                carId : '',
                brandNo : '',
                createTimestampStart : '',
                createTimestampEnd : '',
                orderId : '',
                roleLevel: '',
                agentNo: '',
                partnerTypeCode: ''
          }
        },
        grid_options : {
            height: 190,
            paging: {
                pagerTotal : false,
                hidePageList : false,
                pagerSelect : false
            },
            //autoColumnIndex: true,
            //rowindexColumnFromZero: false,
            columnMapping : [
                //{   key : 'brandId',          hidden: true },
                {   selectorColumn : true ,   title : '선택',        width : '50px', align : 'center' },
                //{   rowindexColumn:true ,     title : 'No',          width : '38px', align : 'center' },
                {   key : 'userName',         title : '작성자',       width : '130px', align : 'center'  },
                {   key : 'createTimestamp',  title : '저장일자',     width : '150px', align : 'center'  },
                {   key : 'brandName',        title : '브랜드',       width : '120px', align : 'center'  }, 
                {   key : 'carId',            title : '차량번호',     width : '140px', align : 'center'  }, 
                {   key : 'orderId',          title : '임시저장번호',  width : '150px',    align : 'center'  },
                {   key : 'amount',           title : '품목수',       width : '60px',    align : 'center'  },
                {   key : 'customerName',     title : '주문처',       width : '250px',    align : 'center' , styleclass : "bordr0"  }

            ]
        }
      }
    }
  },
  created () { //화면상에서 보이지 않는 검색 조건
    //로그인 사용자 정보 초기화
    this.loginInfo = [];
    //대리점 명 세팅값
    this.grid_options.general.params.customerName = '';
    //데이터 숨김, 검색조건 분기 세팅값
    this.grid_options.general.params.roleLevel = '';
    this.grid_options.general.params.agentNo = '';
    this.grid_options.general.params.partnerTypeCode = '';
    //로그인 사용자 정보, 유저 소속 정보 가져오기
    this.getLoginAgentInfo();
  },
  mounted() {

  },
  methods: {
    beforeOpen(e) {
      //화면에서 보이는 검색 조건
      this.tempStorageInfo = [];
      this.grid_options.general.search = '';
      this.gridTotal = 0;
      this.selectBox_options.brandCodeVo = '';
      this.grid_options.general.params.createUserNo = '';
      this.grid_options.general.params.userName = '';
      this.grid_options.general.params.carId = '';
      this.grid_options.general.params.brandNo = '';
      this.grid_options.general.params.createTimestampStart = '';
      this.grid_options.general.params.createTimestampEnd = '';
      this.grid_options.general.params.orderId = '';
      //브랜드 selectbox 코드 넣기
      this.insertBrandCode();

    },
    opened(e) {

      //팝업 진입 자동 조회
      //this.searchTempStorage();

      // 권한에 따른 특정 컬럼 숨기기
      // if(this.loginInfo.roleLevel != '00') {
      //   $("#" + this.grid_options.general.id).alopexGrid('hideCol', 'orderPartnerNo');
      // } esle {
      //   $("#" + this.grid_options.general.id).alopexGrid('hideCol', 'orderPartnerNo');
      // }

      //대리점, 정비소 일때 주문처 disabled
      if(this.grid_options.general.params.roleLevel == '20' ||
          this.grid_options.general.params.roleLevel == '30') {
          $('#customerName').attr('disabled', true);
      }
      //팝업창 스크롤바 css 컨트롤(공통)
      $("#div_tempStoragePopupScroll").mCustomScrollbar( {
        theme: "dark-thick",
        scrollInertia: 500
      });
      //팝업창 닫기 관련 css 컨트롤(공통)
      $("#div_tempStoragePopup").parent().css('overflow', 'visible');
    },
    close() {
      this.$modal.hide('tempStoragePopup');
    },
    searchTempStorage() {
        this.grid_options.general.search = '/tempstorage/list';
        this.grid_options.general.PageInfo.current = 1;
        alert("그리드검색세팅::" + JSON.stringify(this.grid_options.general.params));
        GridModule.searchData(this.grid_options);
        this.getGridListTotal();
    },
    //UI 그리드 왼쪽위 총합 표시 때문에 추가
    getGridListTotal() {
      this.gridTotal = 0;
        Vue.httpClient
        .get('/tempstorage/list', {params : this.grid_options.general.params})
        .then((result) => {
          if ( result.data.result ) {
              this.gridTotal = result.data.result.total;
          }
      })
    },
    getLoginAgentInfo() {
      //로그인 사용자 정보 불러오기
      Vue.httpClient
        .post('/login/check', {})
        .then((result) => {
            this.loginInfo = result.data.result;
            this.grid_options.general.params.roleLevel = this.loginInfo.roleLevel;
            //alert("::::/login/check::::" + JSON.stringify(this.loginInfo));
        if(this.grid_options.general.params.roleLevel == '20' || //대리점
            this.grid_options.general.params.roleLevel == '30') {
              Vue.httpClient
              .get('/tempstorage/usercheck', { params : { userNo : this.loginInfo.userNo }}) //: { userNo : this.loginInfo.userNo }
              .then((result) => {
                  let userCheckInfo = result.data.result.list;
                  for(var key in userCheckInfo) {
                    this.grid_options.general.params.partnerTypeCode = userCheckInfo[key].partnerTypeCode;
                  }
                  if(userCheckInfo != null) { //정비소
                      Vue.httpClient
                        .get('/tempstorage/userinfo', { params : {  userNo : this.loginInfo.userNo, 
                                                                    roleLevel : this.loginInfo.roleLevel,
                                                                    partnerTypeCode : this.grid_options.general.params.partnerTypeCode } })
                        .then((result) => {
                            if(result.data.result) {
                              let agentInfo = result.data.result.list;
                              //alert("::::유저 소속 정보::::\n" + JSON.stringify(agentInfo));
                              for(var key in agentInfo) {
                                //대리점, 정비소 명 세팅
                                this.grid_options.general.params.customerName = agentInfo[key].agentName;
                                //임시저장목록 조회시 주문처 세팅값
                                this.grid_options.general.params.agentNo = agentInfo[key].agentNo;
                              }
                            }
                        }).catch((err)=>{
                            alert("/tempstorage/userinfo:::" + err);
                        })
                  }
              }).catch((err)=>{
                  alert("/tempstorage/usercheck:::" + err);
              })
            }
          }).catch((err)=>{
              alert("/login/check:::" + err);
          })
    },
    sendTempStorageData(e) {
        //기존 선택된 데이터 초기화
        this.tempStorageInfo = [];
        var data = $('#' + this.grid_options.general.id).alopexGrid('dataGet', {_state: {selected:true}});

        if(data != null && data != undefined && data != '') {
            for(var key in data) {
                this.tempStorageInfo.push(data[key]);
            }
        }
        if(this.tempStorageInfo != '' && this.tempStorageInfo != undefined && this.tempStorageInfo != null) {
            //this.$emit('repair-shop-srch-popup-complete', this.tempStorageInfo);
            this.$emit('temp-storage-srch-popup-complete', {result: AlopexGrid.trimData(this.tempStorageInfo[0])});
            this.$modal.hide('tempStoragePopup');
        } else {
            Vue.Alert.alert("임시저장 목록을 선택해주세요");
            return false;
        }
    },
    insertBrandCode () {
      //브랜드 코드 데이터 가져와서 셀렉트박스 넣기
      let serverPageInfo = { current :  1, perPage : 9999};
      Vue.httpClient
      .get('/brand/list', {params : serverPageInfo})
      .then((result) => {
        if ( result.data.result ) {
          let list = result.data.result.list;
          let brandCodeVo = [];
          for(var key in list) {
            brandCodeVo.push({'value':list[key].brandNo, 'text':list[key].brandName});
          }
          this.selectBox_options.brandCodeVo = brandCodeVo;
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/common/TempStoragePopup.vue